<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <div class="card">
        <div class="card-header">
          <i class="icon-globe"></i>Edit Website News
        </div>
        <div class="card-body" v-if="news">
          <div class="form-group">
            <input class="form-control" id="title" v-model="title" type="text" placeholder="Enter your title">
          </div>
          <mavon-editor language='en' v-model="content"/>
          <br>
          <button type="button" @click="createNews" class="btn btn-green float-right" :disabled="!hasPermission(NewsEdit) || this.title.length === 0 || this.content.length === 0 ">Edit</button>
        </div>
      </div>
    </div>
  </div>

</template>


<script>
  import {mavonEditor} from 'mavon-editor'
  import 'mavon-editor/dist/css/index.css'

  import { mapGetters } from 'vuex'
  import VueNotifications from 'vue-notifications'

  export default {
    name: 'EditNews',
    computed: mapGetters({
      news: 'News'
    }),
    components: {
      mavonEditor
    },
    notifications: {
      CreatedNews: {
        type: VueNotifications.types.success,
        title: 'News edited',
        message: 'Your news were successfully edited!'
      }
    },
    created () {
      this.emit('getNews', {'id': Number(this.$route.params.id)})
    },
    watch: {
      news: function (e) {
        this.title = e.title
        this.content = e.message
      }
    },
    data () {
      return {
        title: '',
        content: ''
      }
    },
    methods: {
      createNews () {
        this.CreatedNews()
        this.emit('editNews', {'title': this.title, 'message': this.content, id: this.news.id})
      }
    }
  }
</script>
